import React from 'react';

const JS_Popup_Alert = () => {
  return (
    <div >
      <h1>JS_Popup_Alert</h1>
      <p>Placeholder component for: "JS Popup Alert"</p>
    </div>
  );
};

export default JS_Popup_Alert;
